<template lang="pug">
    .number-spinner
        button.btn-minus(data-dir='dwn' @click="minus($event)")
            i.fa.fa-minus
        input(
            type='text'
            @keypress='validateInput'
            :value="numericValue"
            @input="inputValue"
            )
        button.btn-plus(data-dir='up' @click="plus($event)")
            i.fa.fa-plus
</template>

<script>
    export default {
        name: 'NumberSpinner',
        data() {
            return {
                numericValue: this.value
            }
        },
        props: {
            value: {
                type: Number,
            },
            min: {
                type: Number,
            },
            max: {
                type: Number,
            },
            step: {
                type: Number,
                default: 1
            },
            integerOnly: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            plus: function(event) {
                if(event) event.preventDefault()
                this.numericValue += this.step
            },
            minus: function(event) {
                if(event) event.preventDefault()
                this.numericValue -= this.step
            },
            isInteger(evt) {
                evt = evt ? evt : window.event;
                let key = evt.keyCode || evt.which;
                key = String.fromCharCode(key);
                const regex = /[0-9]/;

                if(!regex.text(key)) {
                    evt.returnValue = false;
                    if(evt.preventDefault) evt.preventDefault();
                }
            },
            isNumber(evt) {
                evt = evt ? evt : window.event;
                var charCode = evt.which ? evt.which : evt.keyCode;

                if(charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            validateInput(evt) {
                if(this.integerOnly === true) {
                    this.isInteger(evt);
                } else {
                    this.isNumber(evt);
                }
            },
            inputValue(evt) {
                this.numericValue = evt.target.value ? parseInt(evt.target.value) : this.min;
            }
        },
        watch: {
            numericValue: function(val, oldVal) {
                if(val <= this.min) {
                    this.numericValue = parseInt(this.min)
                }

                if(val >= this.max) {
                    this.numericValue = parseInt(this.max)
                }

                if(val <= this.max && val >= this.min) {
                    this.$emit('input', val, oldVal)
                }
            }
        },
        // updated() {
        //     if(this.max == 0) {
        //         this.numericValue = 0;
        //     }
        // }

    };
</script>

<style lang="sass">
    @import "@/assets/css/2-base/_variables.sass"
    @import "@/assets/css/2-base/_placeholder.sass"

    .spinner-group
        display: flex 
        align-items: center

        p 
            font:
                size: 15px
                weight: 600
            color: $gray
            margin: 0
            width: 200px   

    .number-spinner
        @extend %flex-center

        button
            @extend %flex-center
            width: 34px
            height: 34px
            border: 1px solid $red
            background: #fff
            outline: none
            border-radius: 50%
            transition: all .3s ease-in-out

            .fa
                color: $red
                -webkit-text-stroke: 1.5px #fff
                transition: all .3s ease-in-out

            &:hover
                background: $red

                .fa
                    color: #fff
                    -webkit-text-stroke: 1.5px $red

        input
            font:
                weight: 600
            color: $gray
            width: 80px !important
            border: none !important
            text-align: center
            background: transparent
</style>


